module.exports = __webpack_public_path__ + "static/media/Inter-Light-BETA.8b411271.woff";